<!-- MFITTの払い戻し完了ダイアログ -->
<template>
  <ItemDialog ref="refundApplicationCompleted" image-type="done">
    <template #content-area>
      <h2>払い戻し申請受付完了</h2>
      <p>
        払い戻し申請を受け付けました。​<br />払い戻し処理には少々お時間を頂きます。​<br />返金までいましばらくお待ちください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogRefundApplicationCompleted",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const refundApplicationCompleted = ref(null);

    const openDialog = () => {
      refundApplicationCompleted.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        refundApplicationCompleted.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      refundApplicationCompleted,
      openDialog,
      closeDialog,
    };
  },
};
</script>
